import { render, staticRenderFns } from "./AddOtherIncomeEntries.vue?vue&type=template&id=ee738938"
import script from "./AddOtherIncomeEntries.vue?vue&type=script&lang=js"
export * from "./AddOtherIncomeEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports